import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import getDeviceId from 'utils/getDeviceId'
import store from 'store'

const deviceId = getDeviceId()
Bugsnag.start({
  maxEvents: 20,
  apiKey: '3b5c729edd509161c152f4771962a054',
  appVersion: process.env.__version__,
  releaseStage: process.env.BUILD_TYPE,
  collectUserIp: true,
  enabledErrorTypes: {
    unhandledExceptions: true,
    unhandledRejections: true
  },
  plugins: [new BugsnagPluginVue()],
  onError(evt) {
    if (evt.originalError?.aborted === true) {
      return false
    }
  }
})

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

Bugsnag.addMetadata('env', { deviceId })

store.watch(
  (state, getters) =>
    [
      getters.curAccountId,
      getters.isMarsco,
      getters.isVirtual,
      getters.isDeposited
    ].join('_'),
  () => {
    if (store.getters.curAccountId) {
      Bugsnag.setUser(store.getters.curAccountId, '***', store.getters.username)
      Bugsnag.addMetadata('env', {
        deviceId,
        account: store.getters.curAccountId,
        marsco: store.getters.isMarsco,
        virtual: store.getters.isVirtual,
        funded: store.getters.isDeposited
      })
    }
  },
  { immediate: true }
)

store.watch(
  (state, getters) =>
    [
      getters.hasHkLv2Permission,
      getters.hasHkLv0Permission,
      getters.hasUsLv1Permission,
      getters.hasUsLv2Permission,
      getters.hasUsOptionPermission,
      getters.hasUsOptTradePermission,
      getters.hasHkTradePermission
    ].join('_'),
  () => {
    Bugsnag.addMetadata('permission', {
      hkLv2: store.getters.hasHkLv2Permission,
      hkLv0: store.getters.hasHkLv0Permission,
      usLv1: store.getters.hasUsLv1Permission,
      usLv2: store.getters.hasUsLv2Permission,
      usOption: store.getters.hasUsOptionPermission,
      usOptTrade: store.getters.hasUsOptTradePermission,
      hkTrade: store.getters.hasHkTradePermission
    })
  }
)

store.watch(
  (state, getters) =>
    [
      (getters.watchListAll || []).length,
      (getters.holdings || []).length,
      !!getters.asset
    ].join('_'),
  () => {
    Bugsnag.addMetadata('portfolio', {
      watchlistCount: (store.getters.watchListAll || []).length,
      holdingsCount: (store.getters.holdings || []).length,
      hasAsset: !!store.getters.asset
    })
  }
)

Vue.log = Bugsnag.notify
